import { EntityRef } from "@amzn/ask-legal-domain";
import {
    Container,
    Icon,
    Link,
    SpaceBetween
} from "@amzn/awsui-components-react";
import * as React from "react";
import { scroller } from "react-scroll";
import { getScrollTargetOffset } from "../../utils/common-utils";
import "../../styles/component/container/container-view-v2.scss";
import "../../styles/component/layout/PageBaseLayout.scss";

// Same gap the original "On This Page" links use when there is no sticky header
const ON_THIS_PAGE_SCROLL_OFFSET_PX = 70;
const BODY_ID = "pf-on-this-page-body";

export const PageOverviewSectionV2 = (props: {
    state: EntityRef[];
    containerNames: { id: string, name: string }[];
    containersDiffMap?: Map<string, string>;
}) => {
    const [expanded, setExpanded] = React.useState<boolean>(true);

    const scrollToContainer = (containerId: string) => {
        scroller.scrollTo(containerId, {
            duration: 500,
            smooth: true,
            offset: -getScrollTargetOffset(ON_THIS_PAGE_SCROLL_OFFSET_PX)
        });
    };

    const hasContainerNames = props.containerNames.length > 0;

    return (
        <Container
            disableHeaderPaddings
            disableContentPaddings
            header={
                <div className={`pf-card-header${expanded ? "" : " pf-card-header--collapsed"}`}>
                    <button
                        type="button"
                        className="pf-card-toggle"
                        aria-expanded={expanded}
                        aria-controls={BODY_ID}
                        onClick={() => setExpanded(!expanded)}
                    >
                        <Icon
                            name={expanded ? "caret-down-filled" : "caret-right-filled"}
                            variant="inverted"
                        />
                        <span className="pf-card-title">On This Page</span>
                    </button>
                </div>
            }
        >
            <nav
                id={BODY_ID}
                aria-label="On this page"
                className={`pf-card-body${expanded ? "" : " pf-card-body--collapsed"}`}
            >
                {hasContainerNames && (
                    <SpaceBetween size="xxs">
                        {props.state.map(c => {
                            const containerName = props.containerNames.find((container) => container.id === c.id);
                            const label = containerName ? containerName.name : c.id;
                            return (
                                <div key={c.id}>
                                    <Link onFollow={() => scrollToContainer(c.id)}>
                                        {props.containersDiffMap?.size > 0 && props.containersDiffMap.get(c.id) ? (
                                            <b>{label}</b>
                                        ) : label}
                                    </Link>
                                    {props.containersDiffMap?.get(c.id) === "INSERTED" && (
                                        <span className="red-label">
                                            &nbsp;
                                            <sup>
                                                <em>new</em>
                                            </sup>
                                        </span>
                                    )}
                                </div>
                            );
                        })}
                    </SpaceBetween>
                )}
            </nav>
        </Container>
    );
};
